var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div><div id=\"capture\"></div><button ng-disabled=\"$ctrl.$cart.bus.isBusy()\" class=\"btn btn-primary\" id=\"buttonTrigger\">Save Card</button></div>";
var id1="cart-creditcard-aptean.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;